<div class="progress-bar bar" [attr.data-label]="label">
  <progress id="bar" min="0" [max]="max" [value]="value"></progress>
</div>
